import { useTranslation } from "react-i18next";

import { router } from "../../app/services/router";
import { A } from "../shared/A";
import { Button } from "../shared/Button";

export const SignUpLink = () => {
  const { t } = useTranslation();
  const { text } = t("features.core.SignUpLink") as unknown as {
    text: string;
  };

  return (
    <Button
      as={A}
      dataLayer={{
        eventAction: "clic",
        eventCategory: "pre_home",
        eventLabel: "creer_un_compte",
      }}
      href={router.getTo("authenticationSignUp")}
    >
      {text}
    </Button>
  );
};
